var map = {
	"./": "../../src/localization/index.js",
	"./ca": "../../src/localization/ca.js",
	"./ca.js": "../../src/localization/ca.js",
	"./en": "../../src/localization/en.js",
	"./en.js": "../../src/localization/en.js",
	"./es": "../../src/localization/es.js",
	"./es.js": "../../src/localization/es.js",
	"./fi": "../../src/localization/fi.js",
	"./fi.js": "../../src/localization/fi.js",
	"./index": "../../src/localization/index.js",
	"./index.js": "../../src/localization/index.js",
	"./locales": "../../src/localization/locales.js",
	"./locales.js": "../../src/localization/locales.js",
	"./pt": "../../src/localization/pt.js",
	"./pt.js": "../../src/localization/pt.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../src/localization sync recursive ^\\.\\/.*$";